import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 35 35"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M23.261 9h2.974l-6.494 7.388 7.639 10.054H21.4l-4.687-6.096-5.357 6.096H8.38l6.944-7.903L8 9h6.132l4.232 5.572zm-1.044 15.673h1.647l-10.63-13.996h-1.768z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }